import * as React from 'react';
import { UitkImage } from 'uitk-react-images';
import { classNames } from 'uitk-react-utils';
import { PlayerStates } from './types.esm.js';
import styles from './uitk-video.css';
import { youTubeThumbnailImage } from './uitk-video-helper.esm.js';
import { UitkVideoLayerLoading } from './uitk-video-layer-loading.esm.js';
import { UitkVideoLayerControls } from './uitk-video-layer-controls.esm.js';

var getClassNameList = classNames.bind(styles);
var playerStateImageVisible = [PlayerStates.get('ended'), PlayerStates.get('unstarted'), PlayerStates.get('cued')];
var UitkVideoLayer = function (_a) {
    var alt = _a.alt, controls = _a.controls, isPlayerReady = _a.isPlayerReady, playerError = _a.playerError, playerState = _a.playerState, src = _a.src, buttonText = _a.buttonText;
    var coverSrc = youTubeThumbnailImage(src);
    var isPlaceholderImageVisibile = playerStateImageVisible.includes(playerState);
    return (React.createElement(React.Fragment, null,
        isPlaceholderImageVisibile && React.createElement(UitkImage, { alt: alt, blankDefault: !coverSrc, src: coverSrc }),
        React.createElement(UitkVideoLayerLoading, { className: getClassNameList({ 'is-hidden': isPlayerReady }), playerState: playerState }),
        React.createElement(UitkVideoLayerControls, { className: getClassNameList({
                'is-hidden': !isPlayerReady || playerError.status,
                'uitk-image-placeholder uitk-image-placeholder-image': !coverSrc && ![PlayerStates.get('playing'), PlayerStates.get('paused')].includes(playerState)
            }), buttonText: buttonText, controls: controls, playerState: playerState })));
};

export { UitkVideoLayer };
